import { combineReducers } from '@ngrx/store';

import {
  abandonedReservationReducer as abandonedReservation
} from '@abandoned-reservation/store/reducers/abandoned-reservation.reducer';
import { UiAbandonedReservationRootReducer as ui } from '@abandoned-reservation/store/reducers/ui';

export const abandonedReservationRootReducer = combineReducers({
  ui,
  abandonedReservation,
});
